import { ROUTES } from "@/lib/constants";
import type { ComparisonRow, PricingRow, UseCaseRow } from "./types";

export const COMPARISON_ROWS: ComparisonRow[] = [
  {
    label: "Typical cost",
    mobile: "From $2/GB",
    residential: "From $1/GB",
  },
  {
    label: "Geographic targeting",
    mobile: "Country, city, and ISP-level targeting",
    residential: "Country, city, and ISP-level targeting across 195+ countries",
  },
  {
    label: "Session behavior",
    mobile: "Rotating or sticky sessions",
    residential: "Rotating or sticky sessions",
  },
];

export const USE_CASE_ROW: UseCaseRow = {
  label: "Best for",
  mobile: [
    { text: "Mobile app testing" },
    { text: "Mobile environments" },
    { text: "Ad verification requiring mobile IPs", href: "/use-cases/ad-verification/" },
  ],
  residential: [
    { text: "Web scraping", href: "/use-cases/web-scraping" },
    { text: "Price monitoring", href: "/use-cases/price-monitoring" },
    { text: "SEO monitoring", href: "/use-cases/seo-monitoring" },
    { text: "Market research", href: "/use-cases/market-research/" },
    { text: "AI data collection", href: "/use-cases/ai-llm-training/" },
  ],
};

export const PRICING_ROW: PricingRow = {
  label: "Pricing",
  mobileHref: ROUTES.pricingMobileProxies,
  residentialHref: ROUTES.pricingResidentialProxies,
};
